/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ChooseLocation/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Admin from './Admin/index'
import No from './No/index'
import React from 'react'
import Support from './Support/index'



/** @type {import('Simple/types.js').View} */
export default function ChooseLocation({
  children,
  viewPath = "/App/ChooseLocation"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let authAccessTokenDataIsSupportValueData = fromData.useDataFormat({ viewPath,
context: 'auth',
path: 'access_token_data.is_support',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: authAccessTokenDataIsSupportValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Admin'}>
<Admin
  viewPath={`${viewPath}/Admin`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Support'}>
<Support
  viewPath={`${viewPath}/Support`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}